// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2e813132] .dot {\n  width: 30px !important;\n  height: 30px !important;\n}", ""]);
// Exports
module.exports = exports;
